<app-breadcrumb *ngIf="name==='Szkolenia'" [master]="'Rejestracje'" [parentName]="'Szkolenia'" [name]="'OFWCA zapisane na egzamin'"></app-breadcrumb>
<app-breadcrumb *ngIf="name==='Egzaminy'" [master]="'Rejestracje'" [parentName]="'Egzaminy'" [name]="'OFWCA zapisane na egzamin'"></app-breadcrumb>
  <div class="ofwca-registered-list-container">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="ofwca-registered-list-filters">

      <app-dict *ngIf="name==='Szkolenia'"
        [multiple]="false" [dictType]="'meeting_type'" [skipKeys]="[MEETING_TYPE_EXAM, MEETING_TYPE_ENTRANCE_EXAM]"
        [label]="'Rodzaj Szkolenia'" class="ofwca-registered-list-filter"
        [(ngModel)]="initialFilters.type" name="type"
      ></app-dict>


      <app-dict-insurance-companies
        [multiple]="false" label="TU"
        class="ofwca-registered-list-filter"
        [(ngModel)]="initialFilters.insuranceCompany" name="insuranceCompany"
      ></app-dict-insurance-companies>

      <app-datepicker
        class="ofwca-registered-list-filter"
        label="Data rozpoczęcia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$startsAt" name="gte$startsAt"
      ></app-datepicker>

      <app-datepicker
        class="ofwca-registered-list-filter"
        label="Data rozpoczęcia do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$endsAt" name="lte$endsAt"
      ></app-datepicker>

      <app-dict
        [multiple]="false"
        label="Status" class="ofwca-registered-list-filter"
        dictType="meeting_status"
        [(ngModel)]="initialFilters.status" name="status"
      ></app-dict>

      <app-dict *ngIf="name==='Egzaminy'"
        [multiple]="false" label="Rodzaj egzaminu" class="ofwca-registered-list-filter"
        dictType="meeting_exam_type"
        [(ngModel)]="initialFilters.examType" name="examType"
      ></app-dict>

      <app-dict
         [multiple]="false"
        label="Typ" class="ofwca-registered-list-filter"
        dictType="meeting_place"
        [(ngModel)]="initialFilters.place" name="place"
      ></app-dict>

      <app-dict-ofwcas
        [multiple]="false"
        label="OFWCA" class="ofwca-registered-list-filter-long"
        [(ngModel)]="initialFilters.ofwca"
        name="ofwca"
      ></app-dict-ofwcas>


    </form>

    <div class="ofwca-list-buttons">
      <button *ngIf="(userPermissions | async).meeting.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>

    <table mat-table [dataSource]="ofwcaMeetings">

      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef> OFWCA </th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca.uuid]">
            {{element.ofwca.firstName}} {{element.ofwca.lastName}}
          </a>
        </td>
      </ng-container>


      <ng-container matColumnDef="pesel">
        <th mat-header-cell *matHeaderCellDef> PESEL OFWCA</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{element.ofwca.pesel}}
          </ng-container>
          <ng-container *ngIf="!(userPermissions | async).ofwca.read">
            <span class="limited-access"><mat-icon matTooltip="Brak dostępu do danych" matTooltipPosition="above">do_not_disturb</mat-icon></span>
          </ng-container>
        </td>
      </ng-container>


      <ng-container matColumnDef="rau">
        <th mat-header-cell *matHeaderCellDef> RAU </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngFor="let rau of element.ofwca.rauNumbers">
            {{rau.rau}} <br>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="partner">
        <th mat-header-cell *matHeaderCellDef> Partner </th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.ofwca.partner?.shortName}}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="partnerNip">
        <th mat-header-cell *matHeaderCellDef> Partner </th>
        <td mat-cell *matCellDef="let element">
         {{element.ofwca.partner?.nip}}
        </td>
      </ng-container>

      <ng-container matColumnDef="assetsRegional">
        <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
        <td mat-cell *matCellDef="let element">
          {{element.ofwca.assetsRegional?.firstName}} {{element.ofwca.assetsRegional?.lastName}}
        </td>
      </ng-container>

      <ng-container matColumnDef="meeting">
        <th mat-header-cell *matHeaderCellDef> Rodzaj </th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/egzaminy-szkolenia/szczegoly', element.meeting.uuid]">
            {{element.meeting.type.name}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="insuranceCompany">
        <th mat-header-cell *matHeaderCellDef> TU </th>
        <td mat-cell *matCellDef="let element">
          <a *ngIf="element.meeting.insuranceCompany !== null" class="default-link" [routerLink]="['/tu/szczegoly', element.meeting.insuranceCompany?.id]">
            {{element.meeting.insuranceCompany?.name}} ({{element.meeting.insuranceCompany?.type?.name}})
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="examType">
        <th mat-header-cell *matHeaderCellDef> Rodzaj egzaminu </th>
        <td mat-cell *matCellDef="let element">
          {{element.meeting.examType?.name}}
        </td>
      </ng-container>


      <ng-container matColumnDef="place">
        <th mat-header-cell *matHeaderCellDef> Typ </th>
        <td mat-cell *matCellDef="let element">
          {{element.meeting.place?.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="link">
        <th mat-header-cell *matHeaderCellDef> Link  </th>
        <td mat-cell *matCellDef="let element">
          {{element.meeting?.link}}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status Egzaminu </th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button [ngClass]="element.meeting.status.color + '-button'">{{element.meeting.status.name}}</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="startsAt">
        <th mat-header-cell *matHeaderCellDef> Data rozpoczęcia </th>
        <td mat-cell *matCellDef="let element">
          {{element.meeting.startsAt | date:'y-MM-dd HH:mm'}} ({{element.meeting.minutesTotal}} min.)
        </td>
      </ng-container>

      <ng-container matColumnDef="passedExam">
        <th mat-header-cell *matHeaderCellDef> Zaliczony egzamin </th>
        <td mat-cell *matCellDef="let element">
          <app-detail-bool [value]="element.passed"></app-detail-bool>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
